import * as React from 'react';
import {Box, Button, Divider, List, ListItem, ListItemText} from '@mui/material';
import {makeStyles} from '@mui/styles';
import {Link} from 'react-router-dom';
import {useGetList} from 'react-admin';
import {subDays} from 'date-fns';
import {getFormattedDateString} from "../DateHelpers";
import {useTranslate} from 'react-admin';

const NewGuardians = ({umbrellaExternalId, charityExternalId}) => {
    const classes = useStyles();

    const translate = useTranslate();

    const aMonthAgo = subDays(new Date(), 30);
    aMonthAgo.setDate(aMonthAgo.getDate() - 30);
    aMonthAgo.setHours(0);
    aMonthAgo.setMinutes(0);
    aMonthAgo.setSeconds(0);
    aMonthAgo.setMilliseconds(0);

    // v2 filter keys are UUID-valued and omitted (not sentineled) when unset — a
    // dash-less `0`/`?? 0` value would be stripped by the provider's
    // sanitizePeopleFilter anyway, but silently, which previously made this widget
    // always show the unscoped list rather than honestly reflecting scope.
    const filter = {
        ...(umbrellaExternalId ? {umbrella_id: umbrellaExternalId} : {}),
        ...(charityExternalId ? {charity_id: charityExternalId} : {}),
    };

    const {data: guardians} = useGetList(
        'guardians',
        {
            sort: {field: 'createDateTime', order: 'DESC'},
            pagination: {page: 1, perPage: 5},
            filter,
        },
    );

    if (!guardians) return null;

    return (
        <div>
            <div>{translate('Last guardians onboarded')}</div>
            <hr />
            <List>
                {guardians
                    ? guardians.map((record) => (
                        <div key={record.id}>
                            <ListItem
                                button
                                to={`/guardians/${record.id}/show`}
                                component={Link}
                                style={{height: 60}}
                            >
                                <ListItemText
                                    primary={getFormattedDateString(record.create_date_time, 'D MMM YYYY') + ` - ${[record.given_name, record.family_name].filter(Boolean).join(' ')}`}
                                />
                            </ListItem>
                            <Divider light={true}/>
                        </div>
                    ))
                    : null}
            </List>
            <Box flexGrow="1">&nbsp;</Box>
            <Button
                className={classes.link}
                component={Link}
                to="/guardians"
                size="small"
                color="primary"
            >
                <Box p={1} className={classes.linkContent}>
                    {translate('Show all guardians')}
                </Box>
            </Button>
        </div>
    );
};

const useStyles = makeStyles(theme => ({
    link: {
        borderRadius: 0,
    },
    linkContent: {
        color: theme.palette.primary.main,
    },
}));

export default NewGuardians;
